var React = require('react');

function BlueArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.385 0.649902L8.89648 2.66106L14.2949 7.05318H0V9.89213H14.2949L8.89648 14.2843L11.385 16.2954L20.9781 8.47266L11.385 0.649902Z","fill":"#1D68AA"}));
}

BlueArrowRight.defaultProps = {"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none"};

module.exports = BlueArrowRight;

BlueArrowRight.default = BlueArrowRight;
